<template>
  <button
    :class="classes"
    :disabled="disabled || loading"
    @click="handleClickLink"
  >
    <k-icon v-if="loading" loop type="Loading" />
    <k-icon v-if="icon && !loading" :type="icon" :size="iconSize" />
    <span v-if="showSlot" ref="slot"><slot></slot></span>
  </button>
</template>

<script>
const prefixCls = "k-btn";

export default {
  name: "k-button",
  props: {
    disabled: Boolean,
    loading: Boolean,
    circle: Boolean,
    long: Boolean,
    icon: { type: String, default: "" },
    type: {
      validator(val) {
        return ["default", "primary", "danger"].includes(val);
      },
      default: "default"
    }
  },
  data() {
    return {
      showSlot: true
    };
  },
  computed: {
    classes() {
      return [
        `${prefixCls}`,
        `${prefixCls}-${this.type}`,
        {
          [`${prefixCls}-circle`]: !!this.circle,
          [`${prefixCls}-icon-only`]: !this.showSlot,
          [`${prefixCls}-loading`]: this.loading,
          [`${prefixCls}-long`]: this.long && this.showSlot
        }
      ];
    },
    iconSize() {
      return this.showSlot ? "14" : "16";
    }
  },
  methods: {
    handleClickLink(event) {
      this.$emit("click", event);
    }
  },
  mounted() {
    this.showSlot = this.$slots.default !== undefined;
  }
};
</script>
